<template lang="pug">
.card.card--blog(:class="{'card--blog-category': isCategoryPage}")
	.card__inner
		.card__img(v-if="!!blog.pagePrimaryImage")
			img(:src="blog.pagePrimaryImage", :alt="blog.blogImageAltText")
		.card__content
			h2.card__heading
				a(:href="blog.system.pageUrl") {{ blog.itemTitle }}
			.card__meta
				time(v-if="!!blog.blogDate", :datetime="datetimeAttr").card__meta-date {{ dateDisplay }}
				.card__meta-topic(v-if="!!blog.documentCategories && blog.documentCategories.length > 0")
					i.card__meta-topic-icon.fg-icon--category
					a(
						v-for="category in blog.documentCategories", 
						:href="categoryHref(category.categoryDisplayName.toLowerCase())"
					) {{ category.categoryDisplayName }}
			.card__copy(v-if="!!blog.pageCopyHtml") {{ truncatedDescription }}
			a(:href="blog.system.pageUrl").card__read-more Read More
</template>

<script>
import { format } from "date-fns";

export default {
	name: "BlogCard",
	props: {
		blog: Object,
		isCategoryPage: Boolean,
	},
	data() {
		return {}
	},
	computed: {
		dateDisplay() {
			return format(new Date(this.blog.blogDate), "MMMM dd, yyyy");
		},
		datetimeAttr() {
			return format(new Date(this.blog.blogDate), "yyyy-MM-dd");
		},
		truncatedDescription() {
			if (!this.blog.pageCopyHtml) return "";
			let descHtmlDiv = document.createElement("div");
			descHtmlDiv.classList.add("blog-card__description--hidden");
			descHtmlDiv.innerHTML = this.blog.pageCopyHtml;
			document.querySelector(".page").appendChild(descHtmlDiv);
			let string;
			if (this.isCategoryPage) {
				string = descHtmlDiv.textContent.substring(0, 84);
			} else {
				string = descHtmlDiv.textContent.substring(0, 120);
			}
			descHtmlDiv.remove();
			return string;
		},
	},
	methods: {
		categoryHref(cat) {
			return `/tank-talk/categories-page/?category=${encodeURI(cat)}/` 
		}
	},
}
</script>

<style lang="scss" scoped>
.card {
	&__heading {
		margin-bottom: 1rem;
	}
	&__meta {
		row-gap: 0.5rem;
		margin-bottom: 1rem;
	}
	&__copy {
		display: inline;
		&::after {
			content: "...\00a0";
		}
		&__read-more {
		font-weight: 700;
		text-transform: uppercase;
		font-size: 0.875rem;
		display: inline-block;
	}
	}
	&__description-hidden {
		display: none;
		}

}
</style>

<style lang="scss">
.card {
	&__copy {
		& * {
			display: inline;
		}
	}
	}
.blog-card__description--hidden {
	display: none;
	visibility: hidden;
}
</style>